module.exports = {
  unexpected: 'Ha ocurrido un error inseperado. Intente más tarde.',
  required: 'Este campo es obligatorio.',
  invalidEmail: 'Ingrese una dirección de correo electrónico válida.',
  contactSuccess: '¡Gracias por contactarnos! En breve responderemos a tu inquietud.',
  commentSuccess: 'El comentario fue publicado exitosamente.',
  commentUpdateSuccess: 'El comentario fue actualizado exitosamente.',
  commentSpam: 'Lo sentimos, su comentario fue marcado como spam.',
  sending: 'Enviando...',
  send: 'Enviar',
  subscribing: 'Suscribiendo...',
  subscribeMe: 'Suscríbeme ahora',
  comment: 'Comentar',
  publishing: 'Publicando...',
  loading: 'Cargando...',
  update: 'Actualizar',
  updating: 'Actualizando...',
  reply: 'Responder'
};



//////////////////
// WEBPACK FOOTER
// ./_js/messages.js
// module id = 5
// module chunks = 0 1 2